<button
  (click)="clicked.emit()"
  [class.disabled]="disabled() === true || isLoading() === true || writeLocked()"
  [disabled]="disabled() === true || isLoading() === true || writeLocked()"
  [matRippleDisabled]="disabled() === true || isLoading() === true || writeLocked()"
  [matTooltipDisabled]="tooltipDisabled() === true"
  [matTooltip]="tooltipText()"
  class="hypecast-primary-button group flex items-center rounded-md text-xl h-12"
  matRipple
>
  <span>{{ submitButtonText() }}</span>
  <div class="flex-initial">
    <ng-content />
  </div>
  @if (isLoading() === true) {
    <div class="flex-initial ml-4">
      <mat-spinner
        [color]="spinnerColor()"
        [diameter]="20"
        [style]="{
          '--mat-progress-spinner-active-indicator-color': spinnerCssColor(),
          color: spinnerCssColor(),
        }"
      />
    </div>
  }
</button>
